if (typeof customElements.get("collapsible-content") === 'undefined') {

class CollapsibleContent extends HTMLElement {
    constructor() {
      super();

      this.accordions = this.querySelectorAll(".accordion");
      this.details = this.querySelectorAll("details");
      this.summaries = this.querySelectorAll("summaries");
      this.bindEvents();
  }

  bindEvents() {
    this.details.forEach((detail) => {
        detail.addEventListener('toggle', this.onDetailToggle.bind(this));
    });
  }

  onDetailToggle(event) {
    if (event.newState === 'open') {
        this.details.forEach((detail) => {
            if (detail != event.target) {
                detail.removeAttribute("open");
                detail.querySelector("summary").setAttribute("aria-expanded", false);
            }
        });
    }
  }
}
  customElements.define('collapsible-content', CollapsibleContent);
}